import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FundShareTakeAction.css'
import config from '../../config'
import analytics from '../../helpers/analytics'
import {
  Link,
  LinkIcon,
  SocialButtons,
  MorningstarLink,
  AboutBanner,
  Returns
} from '../'
// import {Row, Col} from 'react-flexbox-grid'
// import format from '../../helpers/format'
// import convert from '../../helpers/convert'

@CSSModules(Styles)
export default class FundShareTakeAction extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
    shareClass: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
    screen: PropTypes.string
  }
  constructor(props){
    super(props);
  }

  renderTakeAction = (shareClass) =>{
    function renderAction(info, button, link, log) {
      return (
        <div styleName='take-action-action'>
          <div styleName='take-action-info'>{info}</div>
          <div styleName='take-action-button-wrap'>
            <Link
              to={link}
              log={log}
              title={button}>
              <div styleName='take-action-button'>
                {button}<LinkIcon/>
              </div>
            </Link>
          </div>
        </div>
      )
    }

    const screen = this.props.screen || 'all'
    let rating = null
    switch (screen) {
      case 'mil':
        rating = 'grade_military'
        break
      case 'civ':
        rating = 'grade_guns'
        break
      default:
        rating = 'grade_weapons'
        break
    }
    const cleanUrl = config.routes.list + '?dsc=false&srt='+rating+'&screen='+screen

    return (
      <div styleName='take-action-wrap'>
        <div styleName='take-action-anchor' id='take-action'/>
        <div styleName='take-action'>
          <div styleName='take-action-inner'>

            {renderAction( 'Ask your employer about weapon free options for your retirement plan',
            'Use our toolkit', config.routes.toolkit, analytics.eventToToolkit() )}

            {renderAction( 'Find socially responsible funds that are weapon free',
            'Find clean funds', cleanUrl )}

            { /* renderAction( 'CODEPINK invites you to join them in pledging to divest',
            'CODEPINK pledge', config.links.pledge ) */ }

            {renderAction( 'Visit Fossil Free Funds to see exposure to fossil fuels',
            'See climate risk',
            config.links.fffFund+'/'+shareClass.fund_id+'/'+shareClass.investment_vehicle_id,
            analytics.eventToFFF(shareClass.fund_id,shareClass.investment_vehicle_id) )}

          </div>
        </div>
      </div>
    )
  }

  render() {
    const { shareClass, fund, url } = this.props
    return (
      <div>
        { this.renderTakeAction(shareClass) }
        <div styleName='banner'>
          <div styleName='banner-inner'>
            <AboutBanner />
          </div>
        </div>

      </div>
    )
  }
}